'use strict';
var twentyninetimes = twentyninetimes || {};
const countrySelectorTrigger = document.getElementById('js-country-selector-trigger');
const countrySelectorList = document.getElementById('js-country-selector-list');
let isOpen = false;

twentyninetimes.countrySelector = twentyninetimes.countrySelector || function () {

	function init() {
        if(countrySelectorTrigger && countrySelectorList) {
            countrySelectorTrigger.addEventListener('click', function(){
                if(isOpen) {
                    close();
                } else {
                    open();
                }
            });
        }
	}

    function open(){
        countrySelectorList.classList.add('country-selector-list--open');
        isOpen = true;
    }

    function close(){
        countrySelectorList.classList.remove('country-selector-list--open');
        isOpen = false;
    }

	return {
		init : init
	};

}();